import React from 'react';
import { ErrorMessage, Field } from 'formik';
import { MDBInput } from 'mdb-react-ui-kit';

const FormikMdbFieldError = (props) =>
    <div {...props}>
        <strong>{props.children}</strong>
    </div>

export const FormikMdbField = ({
    as=MDBInput, name, label, wrapperClass = "mb-5", touched, errors, ...rest
    }) => {
    let formClass = (touched[name] && errors[name]) ? "is-invalid" : "";

    return <div className={wrapperClass}>
        <Field as={as} className={formClass} name={name} label={label} {...rest}>
            <ErrorMessage className='invalid-feedback' name={name}
                          component={FormikMdbFieldError} />
        </Field>
    </div>
}
